"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type HeroTemplate from "@/templates/Hero";
import { useLocale } from "@/components/providers/LocaleProvider";
import {
  ReadableCopy,
  ReadableValue,
  readableFallback,
} from "@/components/readable";

const Hero = dynamic(() => import("@/templates/Hero"), {
  ssr: false,
  loading: readableFallback("min-h-[600px] lg:min-h-[700px]"),
});

export default function ClientOnlyHero(
  props: ComponentProps<typeof HeroTemplate>,
) {
  const contextLocale = useLocale();

  return (
    <ReadableCopy
      copy={
        <ReadableValue
          value={props}
          locale={props.locale ?? contextLocale}
          level={1}
        />
      }
    >
      <Hero {...props} />
    </ReadableCopy>
  );
}
